enum ExtraBeeswaxFilterControlName {
  ClientCode = 'clientCode',
  ProductCode = 'productCode',
  Estimate = 'estimate',
  Geo = 'geo',
  CashTrade = 'cashTrade',
}

export default ExtraBeeswaxFilterControlName;
